import { format } from '@medflex/i18n';
import { RequestTypes } from '@medflex/shared-types';

const getInquirySubTitle = (inquiry, t) => {
  switch (inquiry.requestType) {
    case RequestTypes.APPOINTMENT:
      return inquiry.appointmentAction
        ? ` - ${t(
            `global:address_book.inquiries.subtitles.appointment.${inquiry.appointmentAction}`,
          )}`
        : '';
    case RequestTypes.FINDINGS_INQUIRY:
      return inquiry.diagnosisRequestType
        ? ` - ${t(
            `global:address_book.inquiries.subtitles.findingsInquiry.${inquiry.diagnosisRequestType}`,
          )}`
        : '';
    default:
      return '';
  }
};

const getInquiryTitle = (inquiry, t) => {
  const { requestType, createdAt } = inquiry.data;
  const typeLabel = t(`global:address_book.inquiries.${requestType}`);

  const subTypeLabel = getInquirySubTitle(inquiry.data, t);
  const date = format(createdAt, 'DD. MMMM');

  return `${typeLabel}${subTypeLabel}, ${date}`;
};

export default getInquiryTitle;
